// Question Types
// 1. MCQs | Multiple Choice | single
// 2. boolean | true/false | single
// 3. MAQs | Multiple Answers | multiple

import { Topic } from '.'

export const solidao: Topic = {
  topic: 'Solidão',
  level: 'Intermediate',
  totalQuestions: 10,
  totalScore: 95,
  totalTime: 600,
  questions: [
    {
      question: 'Com qual frequência você se sente infeliz por realizar muitas atividades sozinho(a)?',
      choices: [
        { choice: "Nunca", score: 1 },
        { choice: "Raramente", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Frequentemente", score: 4 },
        { choice: "Sempre", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com qual frequência você sente que não possui alguém com quem possa conversar?',
      choices: [
        { choice: "Nunca", score: 1 },
        { choice: "Raramente", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Frequentemente", score: 4 },
        { choice: "Sempre", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com qual frequência você sente que é difícil tolerar a sensação de solidão?',
      choices: [
        { choice: "Nunca", score: 1 },
        { choice: "Raramente", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Frequentemente", score: 4 },
        { choice: "Sempre", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com qual frequência você sente que ninguém compreende você?',
      choices: [
        { choice: "Nunca", score: 1 },
        { choice: "Raramente", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Frequentemente", score: 4 },
        { choice: "Sempre", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com qual frequência você se pega esperando por alguém para ligar ou escrever para você?',
      choices: [
        { choice: "Nunca", score: 1 },
        { choice: "Raramente", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Frequentemente", score: 4 },
        { choice: "Sempre", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com qual frequência você se sente completamente sozinho(a)?',
      choices: [
        { choice: "Nunca", score: 1 },
        { choice: "Raramente", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Frequentemente", score: 4 },
        { choice: "Sempre", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com qual frequência você se sente incapaz de estabelecer contato e se comunicar com as pessoas ao seu redor?',
      choices: [
        { choice: "Nunca", score: 1 },
        { choice: "Raramente", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Frequentemente", score: 4 },
        { choice: "Sempre", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com qual frequência você sente um desejo intenso de companhia?',
      choices: [
        { choice: "Nunca", score: 1 },
        { choice: "Raramente", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Frequentemente", score: 4 },
        { choice: "Sempre", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com qual frequência você sente dificuldade em fazer novos amigos?',
      choices: [
        { choice: "Nunca", score: 1 },
        { choice: "Raramente", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Frequentemente", score: 4 },
        { choice: "Sempre", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com qual frequência você se sente excluído e rejeitado pelos outros?',
      choices: [
        { choice: "Nunca", score: 1 },
        { choice: "Raramente", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Frequentemente", score: 4 },
        { choice: "Sempre", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    
    
    
    

  ],
}
